<template>
  <div class="NewQuestionComponent">
    <v-card
      class="ma-0 pa-0"
      color="transparent"
      style="box-shadow: none"
    >
      <slot />

      <v-card-title>
        Add new Question
      </v-card-title>
      <v-card-text>
        <v-form
          ref="newQuestionForm"
          v-model="valid"
          lazy-validation
        >
          <v-autocomplete
            v-model="newQuestion.section_sort_id"
            :disabled="disabled"
            :items="sections"
            item-text="name"
            item-value="position"
            :rules="Rules.required"
            label="Section"
            required
            outlined
          />
          <v-text-field
            v-model="newQuestion.question"
            :disabled="disabled"
            :counter="500"
            :maxlength="500"
            :rules="[
              ...Rules.required,
              ...Rules.max(newQuestion.question, 500)
            ]"
            label="Question text"
            required
            outlined
          />
          <v-autocomplete
            v-model="newQuestion.question_type"
            :disabled="disabled"
            :items="types"
            item-text="name"
            return-object
            :rules="Rules.requiredOption(newQuestion.question_type)"
            label="Question Type"
            required
            outlined
          />
          <v-text-field
            v-if="!newQuestion.question_type.needs_options"
            v-model="newQuestion.placeholder"
            :disabled="disabled"
            :counter="50"
            :maxlength="50"
            label="Placeholder"
            placeholder="e.g. Please enter your answer for X question"
            outlined
          />
          <QuestionOptionsComponent
            v-else
            @newOption="updateOptions($event)"
            @updateOptionsMissing="optionsMissing = false"
          />
          <div
            v-if="optionsMissing"
            class="v-text-field__details v-message-custom"
          >
            <div
              class="v-messages theme--light error--text"
              role="alert"
            >
              <div class="v-messages__wrapper">
                <div class="v-messages__message message-transition-enter-to">
                  At least one option should be added
                </div>
              </div>
            </div>
          </div>
          <v-switch
            v-model="includeDocuments"
            :disabled="disabled"
            label="Include Document(s)"
          />
          <QuestionDocumentsComponent
            v-if="includeDocuments"
            @newDocument="updateDocuments($event)"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          :disabled="disabled"
          @click="addNewQuestion()"
        >
          Add
        </v-btn>
        <v-btn
          color="error"
          :disabled="disabled"
          @click="reset"
        >
          Discard
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'NewQuestionComponent',
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    sections: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    valid: false,
    includeDocuments: false,
    optionsMissing: false,
    newQuestion: {
      question: '',
      question_type: {},
      question_type_type: '',
      placeholder: '',
      section_sort_id: 0
    },
    resetQuestion: {
      question: '',
      question_type: {},
      question_type_type: '',
      placeholder: '',
      section_sort_id: 0
    },
    questionRules: [v => !!v || 'Question is required']
  }),
  computed: {
    types () {
      return this.$store.state.questions.types || []
    }
  },
  created () {
    this.LoadStateDependencies(['questions.types'])
  },
  methods: {
    addNewQuestion () {
      if (this.$refs.newQuestionForm.validate()) {
        if (this.needsOptions()) {
          this.optionsMissing = true
          return
        }
        this.optionsMissing = false
        this.newQuestion.question_type_type = this.newQuestion.question_type.type
        this.$emit('newQuestion', _.clone(this.newQuestion))
        this.reset()
      }
    },
    reset () {
      this.$refs.newQuestionForm.reset()
      this.newQuestion = _.clone(this.resetQuestion)
    },
    updateOptions (options) {
      this.newQuestion.question_options = options
    },
    updateDocuments (documents) {
      this.newQuestion.question_documents = documents
    },
    needsOptions () {
      if (this.newQuestion.question_type.needs_options) {
        if (this.newQuestion.question_options === undefined || this.newQuestion.question_options.length === 0) {
          return true
        }
      }
      return false
    }
  }
}
</script>
<style lang="scss">
.NewQuestionComponent {
    .v-message-custom {
      margin: 8px 0;
      padding: 0 12px;
    }
}
</style>
